import React from "react";
import searchIcon from "../../../../assets/images/SearchIcon.png";
import {
  InputAdornment,
  TextField,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSessionQuizzes,
  QuizPageChanged,
  QuizPageLimit,
  searchQuizKeyChanged,
} from "../../../../redux/slices/session-management.slice";
import deleteIcon from "../../../../assets/images/batchPicture/delete.png";
import Switch from "@mui/material/Switch";
// import AddResourcePopUp from "./AddResourcePopup";
import { useState } from "react";
import axiosInstance from "../../../../axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import { roles } from "../../../sidenav/constant";

const QuizView = ({
  sessionId,
  role,
  levelPermission,
  courseId,
  batchId,
  batchName,
  courseName,
  sessionName,
  dataForPrePath,
  batchType,
}) => {
  const {
    sessionQuizzesData,
    sessionQuizzesLoading,
    sessionQuizzesTotal,
    sessionQuizzesPage,
    sessionQuizzesLimit,
    searchQuizzesKey,
  } = useSelector((state) => state.batchSessionManagement.sessionQuizzes);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      fetchSessionQuizzes({
        sessionId,
        sessionQuizzesPage,
        sessionQuizzesLimit,
        searchQuizzesKey,
      })
    );
  }, [dispatch, sessionQuizzesPage, sessionQuizzesLimit, searchQuizzesKey]);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const getFormattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-US");
  };
  const handleDeleteQuiz = async (id) => {
    const response =
      // {message: response.data.message, isSuccess:response.data.statusCode === 2000}
      await axiosInstance.delete(`/quiz/${id}`);
    if (response.data.statusCode === 200) {
      toast.success(response.data.message);
      dispatch(
        fetchSessionQuizzes({
          sessionId,
          sessionQuizzesPage,
          sessionQuizzesLimit,
          searchQuizzesKey,
        })
      );
    }
  };

  const handlePublishChange = async (data) => {
    const payload = {
      isPublish: !data.isPublish,
    };
    const response =
      // {message: response.data.message, isSuccess:response.data.statusCode === 2000}
      await axiosInstance.patch(`/quiz/${data.id}`, payload);
    if (response.data.statusCode === 200) {
      toast.success(response.data.message);
      dispatch(
        fetchSessionQuizzes({
          sessionId,
          sessionQuizzesPage,
          sessionQuizzesLimit,
          searchQuizzesKey,
        })
      );
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Quiz Name",
      flex: 1,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
              onClick={() =>
                navigate("/batch/quiz-form?formType=edit", {
                  state: {
                    sessionId: sessionId,
                    data: param.row,
                    batchName: batchName,
                    courseName: courseName,
                    dataForPrePath: dataForPrePath,
                    sessionName: sessionName,
                    courseId: courseId,
                    batchId: batchId,
                    batchType: batchType,
                  },
                })
              }
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "13px",
              }}
            >
              {param.row.quizName ? param.row.quizName : ""}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      flex: 1,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
            // onClick={() => HandleTitleClick(param.row)} // Pass the ID value
            >
              {param.row.duration ? param.row.duration : "-"}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "noOfQuestions",
      headerName: "No of questions",
      flex: 1,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
            // onClick={() => HandleTitleClick(param.row)} // Pass the ID value
            >
              {param.row.quizes ? param.row.quizes.length : ""}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "addedOn",
      headerName: "Added On",
      flex: 1,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
            // onClick={() => HandleTitleClick(param.row)} // Pass the ID value
            >
              {param.row.createdDate
                ? getFormattedDate(param.row.createdDate)
                : ""}
            </span>
          </Typography>
        );
      },
    },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   flex: 0.5,
    //   headerClassName: "header-style",
    //   headerStyle: {
    //     backgroundColor: "#f5f5f5",
    //     color: "#333",
    //     fontWeight: "bold",
    //   },
    //   renderCell: (param) => (
    //     <img
    //       src={deleteIcon}
    //       onClick={
    //         role === "Admin" || (role === roles.SUB_ADMIN && levelPermission)
    //           ? () => handleDeleteQuiz(param.row.id)
    //           : () => {}
    //       }
    //       alt="action"
    //       style={{ cursor: "pointer" }}
    //     />
    //   ),
    // },
    {
      field: "publish",
      headerName: "Publish",
      flex: 0.5,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => (
        <div>
          <Switch
            {...label}
            defaultChecked={param.row.isPublish}
            onChange={() => handlePublishChange(param.row)}
            disabled={role === roles.SUB_ADMIN && !levelPermission}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        className="FilterBar--SearchContainer"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div>
          <div
            style={{
              marginTop: "0rem",
              padding: "1rem",
              borderRadius: "0.5rem",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
              width: "75vw",
            }}
          >
            <div>
              <TextField
                // value={searchValue}
                onChange={(e) => dispatch(searchQuizKeyChanged(e.target.value))}
                sx={{
                  backgroundColor: "#F2F2F2",
                  width: "56vw",
                  height: "2.5rem",
                  padding: "0.2rem 2rem 0.5rem 1.5rem",
                  border: "none",
                  borderRadius: ".5rem",
                  paddingBottom: "10px",
                }}
                placeholder="Search Quizess"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={searchIcon}
                        style={{ marginRight: ".4rem" }}
                        alt=""
                      />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                variant="standard"
              />

              {/* <Button
                        sx={{
                          height: "2.5rem",
                          width: "6.5625rem",
                          backgroundColor: "#ffffff",
                          color: "#1A5AFA",
                          borderColor: "#e6e6e6",
                          fontWeight: "600",
                          borderRadius: "0 .5rem .5rem 0 ",
                          textTransform: "capitalize",
                        }}
                        variant="outlined"
                      >
                        Search
                      </Button> */}
              {/* <div style={{ marginLeft: "1rem ", cursor: "pointer" }}>
                        <img
                          onClick={handleAdvanceOpen}
                          style={{ cursor: "pointer" }}
                          src={searchIconFilter}
                          alt="Advance Search"
                        />
                      </div> */}
            </div>

            <div>
              {(role === "Admin" ||
                (role === roles.SUB_ADMIN && levelPermission)) && (
                <Button
                  sx={{
                    height: "2.5rem",
                    width: "10rem",
                    backgroundColor: "#ffffff",
                    color: "#1A5AFA",
                    fontWeight: "bolder",
                    border: "1.5px solid #1A5AFA",
                    marginLeft: "1rem",
                    textTransform: "capitalize",
                  }}
                  variant="outlined"
                  onClick={() =>
                    navigate("/batch/quiz-form?formType=add", {
                      state: {
                        sessionId: sessionId,
                        dataForPrePath: dataForPrePath,
                        batchName: batchName,
                        courseName: courseName,
                        sessionName: sessionName,
                        courseId: courseId,
                        batchId: batchId,
                      },
                    })
                  }
                >
                  + Add Quiz
                </Button>
              )}
            </div>
          </div>
          <Grid
            sx={{
              height: "53vh",
              width: "75vw",
              paddingTop: "0px",
              background: "#ffffff",
            }}
          >
            <DataGrid
              sx={{ border: "0px" }}
              rows={sessionQuizzesData ? sessionQuizzesData : []}
              columns={columns}
              disableColumnMenu
              rowCount={sessionQuizzesTotal}
              loading={sessionQuizzesLoading === "pending"}
              paginationMode="server"
              pageSize={sessionQuizzesLimit}
              page={sessionQuizzesPage}
              rowsPerPageOptions={[25, 50, 100]}
              onPageSizeChange={(newPageSize) =>
                dispatch(QuizPageLimit(newPageSize))
              }
              onPageChange={(newPage) => dispatch(QuizPageChanged(newPage))}
            />
          </Grid>
        </div>
      </div>
    </>
  );
};

export default QuizView;
